export default "__VITE_ASSET__hvWC26Y2__"